import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import CRMPropertyDateInput from 'customer-data-properties/date/CRMPropertyDateInput';
import { MomentTypes } from 'customer-data-properties/date/MomentTypes';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import I18n from 'I18n';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import refObject from 'UIComponents/utils/propTypes/refObject';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
const propTypes = {
  inputRef: refObject.isRequired,
  onChange: PropTypes.func,
  property: PropertyPropType.isRequired,
  value: PropTypes.string
}; // Given a UTC timestamp for midnight on some date in the current user's
// timezone, adds the current time-of-day. Returns the given date, adjusted
// to match the current time-of-day

const addCurrentTimeOfDay = value => {
  const startOfDay = I18n.moment.userTz().startOf('day').valueOf();
  const currentTime = I18n.moment.userTz().valueOf();
  const timeOffset = currentTime - startOfDay;
  return I18n.moment.userTz(value).add(timeOffset).valueOf();
};

const PropertyInputCloseCreateDate = (_ref) => {
  let {
    inputRef,
    onChange,
    property
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["inputRef", "onChange", "property"]);

  const handleChange = useCallback(evt => {
    const {
      target: {
        value
      }
    } = evt;

    if (typeof onChange === 'function') {
      // CRMPropertyDateInput (UIDateInput)'s onChange sends `number | null`; convert to `string | null`
      onChange(value == null ? evt : SyntheticEvent(String(addCurrentTimeOfDay(value))));
    }
  }, [onChange]);
  return /*#__PURE__*/_jsx(CRMPropertyDateInput, Object.assign({}, getTransferrableProps(rest), {
    momentType: MomentTypes.USER,
    onChange: handleChange,
    inputRef: inputRef,
    type: property.type === DATE ? 'date' : undefined
  }));
};

PropertyInputCloseCreateDate.propTypes = propTypes;
export default /*#__PURE__*/memo(PropertyInputCloseCreateDate);